import { render, staticRenderFns } from "./ServiceTerms.vue?vue&type=template&id=6a6fc718"
import script from "./ServiceTerms.vue?vue&type=script&lang=ts"
export * from "./ServiceTerms.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports